import styles from '/builds/sitegeist/cts-reisen/.build/releases/1/src/Cts.CtsReisenDe.GroupTours/Resources/Private/Fusion/Application/GroupToursRFQForm/GroupToursRFQForm.css';
import script from '/builds/sitegeist/cts-reisen/.build/releases/1/src/Cts.CtsReisenDe.GroupTours/Resources/Private/Fusion/Application/GroupToursRFQForm/GroupToursRFQForm.tsx';

export const prototypeName = 'pvXoqqzZK1f4e7WadeV0IRXgbLp2KgfJgb42Z3z4C8GJy4np50Un1DVAKaj9uMb6w1WdpyH8R5RPy72RUWV2QnApLJiWJzp';
export {styles};
export {script};